import { navItemsIds } from "@/utils/nav-items";
import { Menu } from "@mui/icons-material";
import { AppBar, Box, Container, IconButton, useTheme } from "@mui/material";
import { useState } from "react";
import { Link } from "react-scroll";
import { DrawerMenu } from "../DrawerMenu";
import { HeaderMenu } from "./HeaderMenu";
import { headerHeight } from "./utils";

export function Header() {
  const theme = useTheme();
  const [drawerOpen, setDrawerOpen] = useState(false);

  const toggleDrawer = (open: boolean) => () => setDrawerOpen(open);

  return (
    <AppBar
      sx={{
        height: headerHeight,
        backgroundColor: "#fdfdfd",
        justifyContent: "space-between",
        alignItems: "center",
        flexDirection: "row",
        paddingTop: 0.5,
      }}
      elevation={0}
    >
      <Container
        sx={{
          display: "flex",
          justifyContent: {
            xs: "center",
            lg: "space-between",
          },
          alignItems: "center",
          maxWidth: 1150,
          height: {
            xs: 80,
            sm: 100,
          },
          margin: "auto",
          position: "relative",
        }}
      >
        <IconButton
          onClick={toggleDrawer(true)}
          sx={{
            position: "absolute",
            right: 0,
            color: theme.palette.primary.main,
            display: { xs: "block", lg: "none" },
          }}
          aria-label="open-menu"
        >
          <Menu />
        </IconButton>

        <Box maxWidth={100} component={Link} to={navItemsIds.inicio} smooth style={{ cursor: "pointer" }}>
          <img src="white_logo.png" width={"100%"} height={"auto"} alt="logo da restituir" />
        </Box>

        <HeaderMenu />

        <DrawerMenu open={drawerOpen} onClose={toggleDrawer(false)} />
      </Container>
    </AppBar>
  );
}
